/**
 * @generated SignedSource<<e5053033505d18cbf37e49433d6cc3d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type reduceWhitespaceByAvailableSpaceArticle$data = {
  readonly moreOnThisArticles: ReadonlyArray<{
    readonly __typename: "Article";
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "reduceWhitespaceByAvailableSpaceArticle";
};
export type reduceWhitespaceByAvailableSpaceArticle$key = {
  readonly " $data"?: reduceWhitespaceByAvailableSpaceArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"reduceWhitespaceByAvailableSpaceArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "reduceWhitespaceByAvailableSpaceArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "e13f621be951f721967ddae2fb8e9523";

export default node;
